module.exports = __webpack_public_path__ + "static/media/times-solid.2c5552a1.svg";